export const TRAVEL_DATE = 'TRAVEL_DATE';
export const FROM_CITY = 'FROM_CITY';
export const PACKAGE_IDS = 'PACKAGE_IDS';
export const TO_CITY = 'TO_CITY';
export const ROOM_GUEST = 'ROOM_GUEST';
export const DEFAULT_DEPARTURE_CITY = 'New Delhi';
export const RANGE = 'RANGE';
export const DISCRETE = 'DISCRETE';
export const CUSTOMER = 'CUSTOMER';
export const EMI = 'EMI';
export const CASHBACK = 'CASHBACK';
export const FUNCTIONAL = 'FUNCTIONAL';
export const MMT_BLACK = 'MMT_BLACK';
export const WPM = 'WPM';
export const LISTING_PAGE_NAME = 'listing';
export const LISTING_NO_PKG_PAGE_NAME = 'listing_nopk';
export const LISTING_ERROR_PAGE_NAME = 'listing_error';
export const RECENT_VIEW_PACKAGES_POSITION = 1;
export const MAX_TAGS_COUNT = 4;
export const MINIMUM_SCROLL = 68;

export const MAX_MULTI_SELECT_FILTER_VALUE_COUNT = 4;
export const HOTEL_CHOICE_FILTER_ID = 14;
export const SUITABLE_FOR_FILTER_ID = 20;
export const DURATION_FILTER_ID = 12;
export const BUDGET_FILTER_ID = 10;
export const FLIGHT_FILTER_ID = 40;
export const PREMIUM_FILTER_ID = 48;
export const COVIDSAFE_FILTER_ID = 50;
export const PLACES_FILTER_ID = 22;
export const THEMES_FILTER_ID = 18;
export const HOLIDAY_TYPE_FILTER_ID = 30;
export const GENERAL_TAGS_FILTER_ID = 44;
export const WITH_FLIGHT_FILTER_TEXT = 'With Flights';
export const WITH_FLIGHT_FILTER_ID = '1';
export const WITHOUT_FLIGHT_FILTER_TEXT = 'Without Flights';
// AB test values
export const DURATION_FILTER_GRAPH_AB_VALUE = 'duration';
export const BUDGET_FILTER_GRAPH_AB_VALUE = 'budget';
export const HIDE_FILTER_GRAPH_AB_VALUE = 'null';
export const SHOW_ALL_FILTER_GRAPH_AB_VALUE = 'all';
export const CONTACTMGMT_MOUSEOUT_CHAT = 'mouse_out_chat';
export const CONTACTMGMT_MOUSEOUT_QUERY = 'mouse_out_query';
export const CONTACTMGMT_TIMER_QUERY = 'timer_query';
export const CONTACTMGMT_TIMER_CHAT = 'timer_chat';

export const DESTINATION_TYPE = 'DEST';
export const DOM = 'DOM';

export const CALL_BACK_SHOW_PROPERTY = 'callBackShow';
export const CHAT_LIVE_SHOW_PROPERTY = 'chatLiveShow';
export const EMAIL_REGEX = /^.+@.+$/;
export const ALPHABET_REGEX = /^[A-Za-z ]+$/;
export const NUMERIC_REGEX = /^[0-9]*$/;
export const MAX_NAME_LENGTH = 100;
export const MAX_PHONE_NUMBER_LENGTH = 15;
export const MIN_PHONE_NUMBER_LENGTH = 10;
export const PACKAGE_DETAILS_PAGE = 'PackageDetailsPage';
export const PACKAGE_REVIEW_PAGE = 'PackageReviewPage';
export const FORM_DEFAULT_ERROR_MESSAGE = 'Please fill this to proceed.';
export const FORM_DEFAULT_INVALID_MESSAGE = "Seems like you've entered an incorrect value.";
export const CONTACT_MANAGEMENT_RESPONSE_MESSAGES = {
  loading: '',
  success: 'Our team will get in touch with a tailor-made deal especially just for you.',
  error: 'Something went wrong!Please try again later.',
  multipleQueries:
    'We have already received multiple queries from this email address and phone number. Please  allow our holidays expert some time to get back to you.',
};
export const CONTACT_MANAGEMENT_RESPONSE_SHORT_MESSAGES = {
  loading: 'Submitting',
  success: 'Thank you!',
  error: 'Oops!',
  multipleQueries: 'Oops!',
};
export const CONTACT_MANAGEMENT_RESPONSE_LOADING = 'loading';
export const CONTACT_MANAGEMENT_RESPONSE_SUCCESS = 'success';
export const CONTACT_MANAGEMENT_RESPONSE_FAILURE = 'error';

export const INDIA_WEBSITE_VALUE = 'IN';
export const US_WEBSITE_VALUE = 'US';
export const AE_WEBSITE_VALUE = 'AE';

export const INDIA_CURRENCY_CODE = 'INR';
export const US_CURRENCY_CODE = 'USD';
export const AE_CURRENCY_CODE = 'AED';

export const INDIA_LANGUAGE_VALUE = 'en-IN';
export const US_LANGUAGE_VALUE = 'en-US';

export const CHAT_SUBMIT_EVENT = 'event13';
export const QUERY_SUBMIT_EVENT = 'event14';

export const SAVE_PACKAGE_BASE_PATH = '//holidayz.makemytrip.com/holidays/india/savePackage';
export const PACKAGE_BASE_PATH = '/holidays/india/package';
export const LISTING_BASE_PATH = '/holidays/india/search';

export const HOME_PAGE = '//www.makemytrip.com/holidays-india/';

export const RECENTLY_VIEWED_PACKAGES_POSITION = 1;

export const FILTER_URL_NAME_CONSTANTS = {
  BUDGET_FILTER_URL_NAME: 'budget',
  THEME_FILTER_URL_NAME: 'themes',
  SUITABLE_FOR_FILTER_URL_NAME: 'suitableFor',
  HOLIDAY_TYPE_FILTER_URL_NAME: 'holidayType',
  GENERAL_TAG_FILTER_URL_NAME: 'generalTags',
  PACKAGE_INCLUSION_FILTER_URL_NAME: 'packageInclusion',
  HOTEL_CHOICE_FILTER_URL_NAME: 'hotelChoice',
  DURATION_FILTER_URL_NAME: 'duration',
  PLACES_FILTER_URL_NAME: 'places',
};

export const PAGE_NAME = 'DETAILS';

export const PERSUASION_NAME = {
  FETCHING_PACKAGE_PERSUASIONS: 'FETCHING_PACKAGE_PERSUASIONS',
  FETCHING_PACKAGE_PERSUASIONS_SUCCESS: 'FETCHING_PACKAGE_PERSUASIONS_SUCCESS',
  FETCHING_PACKAGE_PERSUASIONS_FAILURE: 'FETCHING_PACKAGE_PERSUASIONS_FAILURE',
  PERSUASIONS_PAGE_NAME: 'DETAILS',
  EMI: 'EMI',
  CASHBACK: 'CASHBACK',
  FUNCTIONAL: 'FUNCTIONAL',
  MMT_BLACK: 'MMT_BLACK',
  WPM: 'WPM',
  PRICE: 'PRICE',
};

export const DEFAULT_ROOM_LISTING = [
  {
    noOfAdults: 2,
    noOfChildrenWOB: 0,
    noOfChildrenWB: 0,
    noOfInfants: 0,
    listOfAgeOfChildrenWB: [],
  },
];

export const MEAL_DATA = {
  MEAL: {
    mealData: {},
    mealLoading: false,
  },
};

export const VISA_DATA = {
  VISA: {
    visaData: {},
    visaLoading: false,
  },
};

export const VARIANT_DATA = {
  VARIANT: {
    variantData: [],
    variantLoading: false,
  },
};

export const FEATURE_DATA_INITIALIZATION = {
  ...MEAL_DATA,
  ...VISA_DATA,
  ...VARIANT_DATA,
};

export const TICKET_STATUS = {
  CLOSED: 'CLOSED',
};
export const PERSUASIONV2 = {
  ABOVE_OFFER_SECTION: 1,
  BELOW_OFFER_SECTION: 2,
};
export const ACCORDIAN_TYPE = {
  CANCELLATION_AND_DATECHANGE: 'CANCELLATION_AND_DATECHANGE',
  TNC: 'TERMS_AND_CONDITION',
};

export const NO_MEAL = 'NO_MEAL';

export const CARD_COLLAPSIBLE_STATE = {
  NONCOLLAPSIBLE: 'NONCOLLAPSIBLE',
  COLLAPSIBLE_EXPANDED: 'COLLAPSIBLE_EXPANDED',
  COLLAPSIBLE_COLLAPSED: 'COLLAPSIBLE_COLLAPSED',
};

export const DFD_MEAL_META_SUBTYPE = {
  DAY_WISE_MEAL: 'DAY_WISE_MEAL',
  PACKAGE_WISE_MEAL: 'PACKAGE_WISE_MEAL',
};

export const PDF_DETAILS_PAGE_SOURCE_LIST = [
  'Email_PDF_PSM',
  'View_your_package_PSM',
  'Whatsapp_Pdf_PSM',
  'Whatsapp_Link_PSM',
];

// Validate Addons Constants
export const VALIDATE_ADDONS_ACTION_TYPES = {
  GET_VALIDATE_ADDONS: 'GET_VALIDATE_ADDONS',
  SET_VALIDATE_ADDONS_RESPONSE: 'SET_VALIDATE_ADDONS_RESPONSE',
  SET_VALIDATE_ADDONS_LOADING: 'SET_VALIDATE_ADDONS_LOADING',
  CLEAR_VALIDATE_ADDONS_RESPONSE: 'CLEAR_VALIDATE_ADDONS_RESPONSE',
  CONTINUE_WITH_ADDON: 'CONTINUE_WITH_ADDON',
  DISMISS_ADDON_MODAL: 'DISMISS_ADDON_MODAL',
  SET_SELECT_ADDON_LOADING: 'SET_SELECT_ADDON_LOADING',
  SET_SELECT_ADDON_ERROR: 'SET_SELECT_ADDON_ERROR',
  SET_MODEL_VIEWED: 'SET_MODEL_VIEWED',
};

export const VALIDATE_ADDONS_MODAL_TYPES = {
  ADDON_UPSELLING: 'ADDON_UPSELLING',
  ADDON_NOTIFICATION: 'ADDON_NOTIFICATION',
};

export const VALIDATE_ADDONS_ACTION_TYPES_API = {
  VIEW_ADDON: 'VIEW_ADDON',
  NOTIFY_ADDON: 'NOTIFY_ADDON',
};

export const VALIDATE_ADDONS_SUBTYPES = {
  VISA_PROTECTION_PLAN: 'VISA_PROTECTION_PLAN',
  INSURANCE: 'INSURANCE',
};

export const VALIDATE_ADDONS_DISPLAY_NAMES = {
  [VALIDATE_ADDONS_SUBTYPES.VISA_PROTECTION_PLAN]: 'VPP',
  [VALIDATE_ADDONS_SUBTYPES.INSURANCE]: 'Travel Insurance',
};

export const VALIDATE_ADDONS_BUTTON_TEXTS = {
  CONTINUE: 'CONTINUE',
  NO_CONTINUE_ANYWAY: 'NO, CONTINUE ANYWAY',
  YES_ADD_INSURANCE: 'YES, ADD INSURANCE',
  UPDATING: 'UPDATING...',
};

export const VALIDATE_ADDONS_MODAL_DATA_TYPES = {
  NOTIFICATION: 'notification',
  UPSELLING: 'upselling',
};
